import { inject, Ref, watch } from "vue";
import Core from "@tmagic/core";
function insertAfter(newElement: Element, targetElement: Element) {
  const parent: Element = targetElement.parentNode;

  if (parent.lastChild == targetElement) {
    parent.appendChild(newElement);
  } else {
    parent.insertBefore(newElement, targetElement.nextSibling);
  }
}

function removeDom(el: Element) {
  const parent: Element = el.parentNode;
  parent.removeChild(el);
}

const showErrorTips = (errorTips: Ref<string>, ref: Ref<Element>, config: any) => {
  if (config.verification.showErrorType !== 1) {
    return;
  }
  const app: Core = inject("app")!;
  const div = document.createElement("div");
  div.style.color = "red";
  div.style.fontSize = "10px";
  div.style.position = "absolute";
  if (config.verification.systemShowErrorType === 2) {
    div.style.left = "100%";
    div.style.top = "50%";
    div.style["margin-left"] = "4px";
    div.style.transform = "translateY(-50%)";
  } else {
    div.style.marginTop = "4px";
  }

  watch(
    () => errorTips.value,
    (val) => {
      if (config.verification.systemShowErrorType === 3) {
        if (!val) return;
        app.toast({
          message: config.label.text+ '校验失败:' + val,
          duration: 2000,
          type: "error",
        });
        errorTips.value = "";
        return;
      }
      if (val && typeof val == "string") {
        const position = getComputedStyle(ref.value).position;
        div.style.width = ref.value.offsetWidth + "px";
        if (position === "absolute" || position === "fixed") {
          div.style.position = position;
          div.style.left = ref.value.offsetLeft + "px";
          div.style.top = ref.value.offsetTop + ref.value.offsetHeight + 4 + "px";
        }

        div.innerHTML = val;
        ref.value.appendChild(div);
      } else {
        removeDom(div);
      }
    }
  );
};

export default showErrorTips;
